import { useEffect, useRef, useState } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Box, Button, FormControlLabel, FormGroup, Grid, Stack, Switch, TextField, Typography } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import OAuthService from "src/app/auth/services/oAuthService";
import moment from "moment";
import { checkAccountNumber, checkBlankSpace, checkIBAN, checkNumber, checkSpecialChar } from "../../utilities/FormValidation";
import CustomDatePicker from "../../utilities/CustomDatePicker";

const FinanceTab = (props) => {
    const [financeId, setFinanceId] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [errorMsg, setErrorMsg] = useState();
    const [editData, setEditData] = useState();
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [validError, setValidError] = useState({});
    const [financeData, setFinanceData] = useState({
        // "trnNo": "",
        "financialYearStartDate": null,
        "financialYearEndDate": null,
        "bankDetails": [
            {
                "accountName": "",
                "bankName": "",
                "swiftCode": "",
                "accountNumber": 0,
                "iban": "",
                "defaultAccount": false,
            }
        ]
    })
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companyInfoes}`;
    
    const handleSubmitDocument = async () => {
        let financeObject = {
            ...financeData,
            companyId: `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/${Number(props.companyCode)}`
        };
        setSuccessMsg('')
        try {
            if (financeId) {
                const updateData = await OAuthService.putData(url + `/${financeId}`, financeObject);
                if (updateData.data) {
                    setSuccessMsg("Finance data updated successfully")
                    setSaveDisabled(true);
                    setFinanceData(updateData.data);
                    setEditData(JSON.parse(JSON.stringify(updateData.data)))
                }
            } else {
                const infoUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companyInfo}`;
                const finance = await OAuthService.getList(infoUrl + `/getAdditionalDetail?companyId=${props.companyCode}`);
                if(finance?.data && finance?.data?.id){
                    const updateData = await OAuthService.putData(url + `/${finance?.data?.id}`, financeObject);
                    if (updateData.data) {
                        setSuccessMsg("Finance data updated successfully")
                        setSaveDisabled(true);
                        setFinanceData(updateData.data);
                        setEditData(JSON.parse(JSON.stringify(updateData.data)))
                    }
                }else{
                    const submitData = await OAuthService.addData(url, financeObject);
                    if (submitData.data) {
                        setFinanceId(submitData.data.id)
                        setSuccessMsg("Finance data added successfully")
                        setSaveDisabled(true);
                        setFinanceData(submitData.data);
                        setEditData(JSON.parse(JSON.stringify(submitData.data)))
                    }
                }
            }

        } catch (error) {
            setErrorMsg(error?.response?.data?.errorMessage || error.message)
        }
    }
    const checkFinanceData = async () => {
        try {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companyInfo}`;
            const finance = await OAuthService.getList(url + `/getAdditionalDetail?companyId=${props.companyCode}`);
            if (finance?.data) {
                setFinanceId(finance?.data?.id);
                let obj = {...finance?.data};
                if(!finance?.data?.bankDetails || finance?.data?.bankDetails.length === 0){
                    obj = {...obj , bankDetails : [
                        {
                            "accountName": "",
                            "bankName": "",
                            "swiftCode": "",
                            "accountNumber": 0,
                            "iban": "",
                            "defaultAccount": false,
                        }
                    ]};
                }
                setFinanceData(obj);
                setEditData(JSON.parse(JSON.stringify(obj)))
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        if (props.companyCode) {
            checkFinanceData();
        }
    }, [props.companyCode])

    const handleFinanceDataChange = (fieldName, value, index) => {
        if (index >= 0) {
            let bankDetails = [...financeData.bankDetails];
            bankDetails[index][fieldName] = value;
            setFinanceData({ ...financeData, "bankDetails": bankDetails })
        } else {
            setFinanceData({ ...financeData, [fieldName]: value });
        }
    }

    const addBankDetails = () => {
        if (financeData.bankDetails && financeData.bankDetails.length > 0) {
            setFinanceData({
                ...financeData, bankDetails: [...financeData.bankDetails, {
                    "accountName": "",
                    "bankName": "",
                    "swiftCode": "",
                    "accountNumber": 0,
                    "iban": "",
                    "defaultAccount": false,
                }]
            })
        } else {
            setFinanceData({
                ...financeData, bankDetails: [{
                    "accountName": "",
                    "bankName": "",
                    "swiftCode": "",
                    "accountNumber": 0,
                    "iban": "",
                    "defaultAccount": false,
                }]
            })
        }
    }

    const deleteBankDetails = (index) => {
        const details = financeData.bankDetails.filter((data, key) => { if (key !== index) { return data; } })
        setFinanceData({
            ...financeData, bankDetails: details
        })
    }

    useEffect(() => {
        props.setAllSuccessMsg(successMsg)
    }, [successMsg]);

    useEffect(() => {
        props.setAllErrorMsg(errorMsg)
    }, [errorMsg])
   
    useEffect(() => {
        if (financeId) {
            if ((Object.values(validError).filter(o => o !== undefined && o !== "").length > 0 || JSON.stringify(editData) === JSON.stringify(financeData))) {
                setSaveDisabled(true);
            } else {
                setSaveDisabled(false)
            }
        } else {
            if ((Object.values(validError).filter(o => o !== undefined && o !== "").length > 0 || (financeData.financialYearEndDate === null && financeData.financialYearStartDate === null))) {
                setSaveDisabled(true);
            } else {
                setSaveDisabled(false)
            }
        }

    }, [validError, financeData,editData])

    return (
        <>
            <Grid className="flex flex-row mb-10" justifyContent="flex-end" alignItems="flex-end">
                <Button variant="contained"
                    color="secondary"
                    onClick={handleSubmitDocument}
                    disabled={saveDisabled}
                >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                </Button>
            </Grid>
            {/* <Accordion className="mb-10">
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography>Finance Detail</Typography>
                </AccordionSummary>
                <AccordionDetails> */}
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Box className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>
                        <Stack spacing={2}>
                            {/* <Stack>
                                <label>TRN No.</label>
                                <TextField
                                    name="trnNo"
                                    value={financeData.trnNo}
                                    onChange={(e) => handleFinanceDataChange('trnNo', e.target.value)}
                                    error={validError.trnNo ? true : false}
                                    onKeyUp={(e) => setValidError({ ...validError, trnNo: e.target.value ? checkNumber(e.target.value) : '' })}
                                    helperText={validError.trnNo}
                                />
                            </Stack> */}
                            <Stack>
                                <label>Financial Year Period*</label>
                                <div className="flex flex-row">
                                    <CustomDatePicker
                                        format={'dd-MM-XXXX'}
                                        value={financeData.financialYearStartDate}
                                        handleChange={(e) => handleFinanceDataChange('financialYearStartDate', moment(e).format("YYYY-MM-DD"))}
                                    />
                                    <Typography className="p-7 leading-9"> - </Typography>
                                    <CustomDatePicker
                                        format={'dd-MM-XXXX'}
                                        value={financeData.financialYearEndDate}
                                        minDate={new Date(financeData.financialYearStartDate)}
                                        handleChange={(e) => handleFinanceDataChange('financialYearEndDate', moment(e).format("YYYY-MM-DD"))}
                                    />
                                </div>
                            </Stack>
                        </Stack>
                    </Box>
                    <Box className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>
                        <Stack spacing={2}>
                            <Stack>
                                <label>Created At</label>
                                <TextField
                                    disabled
                                    value={financeData?.createdAt}
                                />
                            </Stack>
                            <Stack>
                                <label>Created By</label>
                                <TextField
                                    disabled
                                    value={financeData?.createdBy}
                                />
                            </Stack>
                            <Stack>
                                <label>Updated At</label>
                                <TextField
                                    disabled
                                    value={financeData?.updatedAt}
                                />
                            </Stack>
                            <Stack>
                                <label>Updated By</label>
                                <TextField
                                    disabled
                                    value={financeData?.updatedBy}
                                />
                            </Stack>
                        </Stack>
                    </Box>
                </Grid>
                <Grid item xs={6}>
                    {(financeData?.bankDetails && financeData?.bankDetails.length > 0) && financeData?.bankDetails.map((bank, index) => {
                        return (
                            <Box className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>
                                <Stack spacing={2}>
                                    <Grid container>
                                        <Grid xs={6} item><label>Bank Details</label></Grid>
                                        <Grid xs={6} item className="flex flex-row mb-10" justifyContent="flex-end" alignItems="flex-end">
                                            {index === 0 && <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={(e) => {
                                                    addBankDetails(index)
                                                }}
                                            >
                                                <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                                            </Button>}
                                            {index !== 0 && <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={(e) => {
                                                    deleteBankDetails(index)
                                                }}
                                            >
                                                <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
                                            </Button>}
                                        </Grid>
                                    </Grid>
                                    <Stack>
                                        <label>Account Name</label>
                                        <TextField
                                            name={'accountName'}
                                            value={bank.accountName}
                                            onChange={(e) => handleFinanceDataChange('accountName', e.target.value, index)}
                                            error={validError['accountName' + index] ? true : false}
                                            onKeyUp={(e) => setValidError({ ...validError, ['accountName' + index]: checkSpecialChar(e.target.value) })}
                                            helperText={validError['accountName' + index]}
                                        />
                                    </Stack>
                                    <Stack>
                                        <label>Bank Name</label>
                                        <TextField
                                            name={'bankName'}
                                            value={bank.bankName}
                                            onChange={(e) => handleFinanceDataChange('bankName', e.target.value, index)}
                                            error={validError['bankName' + index] ? true : false}
                                            onKeyUp={(e) => setValidError({ ...validError, ['bankName' + index]: checkSpecialChar(e.target.value) })}
                                            helperText={validError['bankName' + index]}
                                        />
                                    </Stack>
                                    <Stack>
                                        <label>Swift Code</label>
                                        <TextField
                                            name={'swiftCode'}
                                            value={bank.swiftCode}
                                            error={validError['swiftCode' + index] ? true : false}
                                            onKeyUp={(e) => setValidError({ ...validError, ['swiftCode' + index]: checkBlankSpace(e.target.value) })}
                                            helperText={validError['swiftCode' + index]}
                                            onChange={(e) => handleFinanceDataChange('swiftCode', e.target.value, index)}
                                        />
                                    </Stack>
                                    <Stack>
                                        <label>Account No</label>
                                        <TextField
                                            name={'accountNo'}
                                            value={bank.accountNumber}
                                            error={validError['accountNumber' + index] ? true : false}
                                            onChange={(e) => handleFinanceDataChange('accountNumber', Number(e.target.value), index)}
                                            onKeyDown={(e) => setValidError({ ...validError, ['accountNumber' + index]: checkAccountNumber(e.target.value) })}
                                            helperText={validError['accountNumber' + index]}
                                        />
                                    </Stack>
                                    <Stack>
                                        <label>IBAN</label>
                                        <TextField
                                            name={'iban'}
                                            value={bank.iban}
                                            error={validError['iban' + index] ? true : false}
                                            onChange={(e) => handleFinanceDataChange('iban', e.target.value, index)}
                                            onKeyDown={(e) => setValidError({ ...validError, ['iban' + index]: checkIBAN(e.target.value) })}
                                            helperText={validError['iban' + index]}
                                        />
                                    </Stack>
                                    <Stack className="mb-16">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={bank.defaultAccount}
                                                    onChange={(e) => handleFinanceDataChange('defaultAccount', e.target.checked, index)}
                                                  />
                                                }
                                                label="Is Default Account"
                                            />
                                        </FormGroup>
                                    </Stack>
                                </Stack>
                            </Box>
                        )
                    })}

                </Grid>
            </Grid>

            {/* </AccordionDetails>
            </Accordion> */}
        </>
    )
}

export default FinanceTab;